import React from 'react';
import { } from '@mui/material';
import BiophyHerosection from '../components/IntrinsicBiophy/BiophyHerosection';
import BiophyServicesection from '../components/IntrinsicBiophy/BiophyServiceSection';  
const IntrinsicBiophy = () => {
  

  return (
    <>
           
            <BiophyHerosection/>
            <BiophyServicesection/>

      
    </>
  );
};

export default IntrinsicBiophy;